export default __webpack_public_path__ + "static/media/deadplants.b1a9901f.png";